exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider[data-v-7578d6c0]{position:relative;color:#3394e1;display:block;width:100%;height:1px;margin:24px 0;margin-bottom:30px;background:#3394e1}.divider-text[data-v-7578d6c0]{color:#3394e1;-webkit-transform:translateY(-50%);transform:translateY(-50%);left:38px;position:absolute;background-color:#fff;padding:0 20px;font-weight:500;font-size:14px}.left[data-v-7578d6c0]{left:38px}.right[data-v-7578d6c0]{right:38px}.center[data-v-7578d6c0]{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}", ""]);

// exports
